import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get the language from localStorage, sessionStorage, or a service
    const language = localStorage.getItem('lang') || 'en-US'; // Default to 'en' if not set

    // Clone the request and add the Accept-Language header
    const modifiedReq = req.clone({
      setHeaders: {
        'Accept-Language': language,
      },
    });

    // Pass on the modified request
    return next.handle(modifiedReq);
  }
}
